import pluralize from 'pluralize'

export const ASSESSMENT_COMMENTS_LABELS = {
  title: 'Internal comments',
  search: 'Search…',
  closeSearch: 'Close search',
  options: 'Comment options',
  allComments: 'All comments',
  onlyYourThreads: 'Only your threads',
  composerPlaceholder: 'Write a comment…',
  firstCommentPlaceholder: 'Start discussion…',
  replyPlaceholder: 'Reply to this thread…',
  collapse: 'Collapse',
  loading: 'Loading comments',
  noFilterResults: 'No comments in your threads yet',
  emptyTitle: 'Start a team discussion',
  emptySubtitle:
    'Align your teammates, flag concerns, and make decisions privately — before responding to the vendor.',
} as const

export const repliesLabel = (count: number) => pluralize('reply', count, true)

export const commentsTabLabel = (hasUnread: boolean) =>
  hasUnread ? `${ASSESSMENT_COMMENTS_LABELS.title} — Unread` : ASSESSMENT_COMMENTS_LABELS.title

export const noSearchResultsMessage = (query: string) => `No comments match "${query}"`
